import * as React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardActions,
  Stack,
  useTheme,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import FruitifyIcon from "../../../shared-components/FruitifyIcons";
import { ChevronRight, Edit } from "@mui/icons-material";
import ExpandableTagsBox from "../../../shared-components/ExpandableTagsBox";

function QuizGroupSummaryCard({
  quizGroup,
  showAnswerCount = false,
  studentView = false,
  showTypeChip = false,
}) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Card
      data-testid={"quiz-group-summary-card"}
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "100%", // stretch to fill Grid item
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Typography
            variant="h6"
            color="text.primary"
            gutterBottom
            sx={{ mb: 0 }}
          >
            {quizGroup.name}
          </Typography>
          {showTypeChip && (
            <Chip label="Quiz" variant="outlined" size="small" />
          )}
          {quizGroup.isPublished && (
            <Chip
              label={quizGroup.status}
              color={
                quizGroup.status === "Past Deadline" ? "warning" : "success"
              }
              variant={
                quizGroup.status === "Past Deadline" ? "outlined" : "filled"
              }
              size="small"
            />
          )}
        </Stack>
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          sx={{ mt: 1.5, mb: 1 }}
        >
          <FruitifyIcon
            name={"CalendarToday"}
            sx={{
              width: 18,
              height: 18,
              color: theme.palette.text.secondary,
            }}
          />
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            <strong>Due: </strong>
            {quizGroup.dueDate}
          </Typography>
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          {showAnswerCount ? (
            <>
              <FruitifyIcon
                name={"Assignment"}
                sx={{
                  width: 18,
                  height: 18,
                  color: theme.palette.text.secondary,
                }}
              />
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Answers: </strong>
                {quizGroup.answersCount}
              </Typography>
            </>
          ) : (
            <>
              <FruitifyIcon
                name={"School"}
                sx={{
                  width: 18,
                  height: 18,
                  color: theme.palette.text.secondary,
                }}
              />
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Class: </strong>
                {quizGroup.schoolClass.name}
              </Typography>
            </>
          )}
        </Stack>
        <ExpandableTagsBox tags={quizGroup.tags} />
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end", pt: 0, mt: -0.5 }}>
        <Button
          variant="card-action"
          color="primary"
          onClick={() => navigate(`/quizzes/view/${quizGroup.id}`)}
          endIcon={quizGroup.isPublished ? <ChevronRight /> : <Edit />}
        >
          {quizGroup.isPublished
            ? studentView
              ? "Submit"
              : "Review"
            : "Continue"}
        </Button>
      </CardActions>
    </Card>
  );
}

export default QuizGroupSummaryCard;
